export const getApiErrorMessage = (error: Record<string, any>) => {
    if (error.response?.data?.errors?.fields) {
        let message = '';
        Object.keys(error.response.data.errors.fields).forEach((field) => {
            message += `${field}: ${error.response.data.errors.fields[field]}\n`;
        });
        return message;
    }

    if (error.response?.data?.message) {
        return error.response.data.message;
    }

    if (error.response?.data) {
        return error.response?.data;
    }

    return error;
}